import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export function useUpdateCheckInSessionMutation() {
  const apiClient = useAPIClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn({
      sessionId,
      siteId,
      visitId,
    }: {
      sessionId: string;
      siteId: string;
      visitId: string;
    }) {
      return apiClient.siteCheckinSession.updateSession(
        { siteId, sessionId },
        { conciergeState: visitId }
      ).result;
    },
    onError: (error) => logError(error),
  });
}
